<style scoped>
.ivu-layout-header {
  padding-left: 0px;
  padding-right: 0px;
  background: white;
  height: 60px;
}

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.layout-logo {
  width: 360px;
  height: 60px;
  background: url("../assets/images/dms_logo.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  border-radius: 3px;
  float: left;
  position: relative;
}

.layout-nav {
  width: 900px;
  margin: 0 auto;
  margin-left: 250px;
  padding-left: 40px;
  font-size: 18px;
  font-weight: 700;
}

.layout-nav a {
  font-size: 18px;
  margin-right: 10px;
}

.ivu-menu-light {
  background: rgba(255, 255, 255, 1);
}

.ivu-layout {
  background: rgba(242, 242, 242, 1);
}

.layout-nav-userinfo {
  margin-right: 70px;
  width: 150px;
  float: right;
  z-index: 900;
  margin-top: -70px;
  position: relative;
}

.layout-nav-info {
  margin-left: 30px;
  width: 100px;
  float: left;
  z-index: 900;
  margin-top: -65px;
  position: relative;
}

.user {
  float: right;
  margin-top: 18px;
  line-height: 20px;
}

.layout-nav-right {
  width: 60px;
  margin-top: -60px;
  height: 60px;
  background: url("../assets/images/account.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  border-radius: 3px;
  float: right;
  z-index: 900;
  position: relative;
  cursor: pointer;
}

.layout-nav-right {
  display: flex;
  justify-content: flex-end;
}

.userinfop {
  text-align: right;
  font-weight: 700;
  color: #4060ad;
  white-space: nowrap;

}

.account {
  margin-top: 60px;
  overflow: hidden;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  box-sizing: border-box;
  border-radius: 4px;
  z-index: 900;
  display: none;
}

.layout-nav-right:hover .account {
  display: block;
}

.ivu-select-item:hover {
  background: #f3f3f3
}
</style>
<template>
  <div class="layout">
    <Layout>
      <Header>
        <Menu mode="horizontal" :active-name="activename" @on-select="menuonselect">
          <div class="layout-logo"></div>
          <div class="layout-nav">

            <MenuItem name="1" to="/Index/MyTask"> 首页
            </MenuItem>
            <MenuItem v-if="!user.is_staff && (isDistributor || isDistributor_service)" name="2" to="/Distributor/Distributormaster"> 资料信息
            </MenuItem>
            <MenuItem
              v-if="(!user.is_staff && isDistributor_service_two && !isDistributor_service && !isDistributor)
              || (!user.is_staff && isDistributorTwo && !isDistributor && !isDistributor_service)"
              name="3" to="/DistributorTwo/DistributorTwoMaster"> 资料信息
            </MenuItem>
            <!--TODO-->
            <!--<MenuItem v-if="!user.is_staff" name="4" to="/Workflow/Index"> 申请提交-->
            <!--</MenuItem>-->
            <MenuItem name="4" to="/Workflow/Index"> 申请提交
            </MenuItem>

            <MenuItem v-if="user.is_staff " name="5" to="/Search/Distributorinformation"> 信息查询
            </MenuItem>
            <!--<MenuItem v-if="isDistributor && !isDistributorTwo" name="6" to="/Search/SecondaryDelegateinformation"> 信息查询-->

            <!--</MenuItem>-->
            <MenuItem v-if="(isDistributor || isDistributor_service) && !user.is_staff" name="7" to="/Search/DelegateOne"> 信息查询
            </MenuItem>
            <MenuItem v-if="((isDistributorTwo && !isDistributor) || isDistributor_service_two) && !isDistributor && !isDistributor_service && !user.is_staff" name="8"
                      to="/Search/SecondaryDelegateinformation"> 信息查询
            </MenuItem>
            <MenuItem  v-if="user.is_staff" name="9" to="/SetUp"> 设置

            </MenuItem>


            <!--<MenuItem v-if="operate" name="10" to="/Tool"> 工具库存-->
          <!--<MenuItem v-if="operate" name="10" to="/Tool/dealerInventory"> 工具库存 </MenuItem>-->

              <!--<MenuItem name="11" to="/Index/Home"> 信息资讯-->
              <!--</MenuItem>-->

            <!--</MenuItem>-->
            <!--          <MenuItem name="5" to="/IndexTwo/MyTaskTwo"> 二期-->
            <!--          </MenuItem>-->

          </div>

        </Menu>


        <div>

          <div class="layout-nav-right">

            <ul class="account">
              <li class="ivu-select-item" @click="EmailModal=true,isOK=true" v-show="!user.is_staff">
                <Icon type="md-mail"/>
                <span style="margin-left:15px;">修改邮箱</span></li>
              <li class="ivu-select-item" @click="passwordModal=true">
                <Icon type="md-key"/>
                <span style="margin-left:15px;">修改密码</span></li>
                <li class="ivu-select-item">
                    <span v-if="isDistributor" >
                        <Icon type="md-mail"/>
                        <a @click="downloadAttachment" style="margin-left:15px;">操作指南</a>
                    </span>
                    <span v-if="isDistributorTwo" >
                        <Icon type="md-mail"/>
                        <a @click="downloadAttachmentTwo" style="margin-left:15px;">操作指南</a>
                    </span>
                    <span v-if="isDistributor_service">
                        <Icon type="md-mail"/>
                        <a @click="downloadAttachment_service" style="margin-left:15px;">操作指南</a>
                    </span>
                    <span v-if="isDistributor_service_two">
                        <Icon type="md-mail"/>
                        <a @click="downloadAttachmentTwo_service" style="margin-left:15px;">操作指南</a>
                    </span>
                </li>
              <li class="ivu-select-item" @click="quit">
                <Icon type="md-log-out"/>
                <span style="margin-left:15px;">退出</span>
              </li>

            </ul>

          </div>
          <div class="layout-nav-userinfo">
            <div class="user">
              <p class="userinfop">{{ user.username }}</p>
              <p class="userinfop">
                {{ user.chinese_full_name == null || user.chinese_full_name == "" || user.chinese_full_name == undefined ? user.company_name : user.chinese_full_name }}</p>
            </div>
          </div>

        </div>
      </Header>
      <Layout>
        <router-view/>
      </Layout>
      <footer style="text-align: center;">
        <h1 style="    font-size: 110%;">系统版本4.1.1, 系统支持: chen.dongliang@xisheninfo.com</h1>
        <br>
      </footer>
    </Layout>

    <Modal v-model="EmailModal" title="邮箱信息修改" :styles="{top: '250px'}">
      <p slot="header">
        <span>邮箱信息修改</span>
      </p>
      <div>
        <Form ref="EmaiformValidate" :rules="ruleValidate" :model="Email">
          <Row>
            <Col>
              <FormItem label="邮箱地址" prop="Email">
                <Input v-model="Email.Email" placeholder="请输入邮箱地址" @on-blur="getEmail('EmaiformValidate')">
                  <Icon type="md-mail" slot="prefix"/>
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="EmailModal=false">取消</Button>
        <Button type="success" @click="emailOk('EmaiformValidate')">确定</Button>
      </div>
    </Modal>

    <Modal v-model="passwordModal" title="密码修改" :styles="{top: '100px'}" :closable="false" :mask-closable="false">
      <Form ref="Password" :model="Password">
        <FormItem prop="password">
          <span style="color: red">1)密码至少12位</span><br>
          <span style="color: red">2)密码至少需包含4类字符中的3个:大写字母，小写字母，数字，特殊字符</span><br>
          <span style="color: red">3)不能包含字典中的单词，明显的键盘顺序，可猜测的数字例如生日</span><br>
          <span style="color: red">4)新密码不应使用与旧密码相同的5个连续字符。</span><br>
        </FormItem>
        <FormItem prop="oldPassword">
          <FormItem label="旧密码">
            <Input type="password" v-model="Password.old_password" placeholder="请输入旧密码">
              <Icon type="md-lock" slot="prefix"/>
            </Input>

          </FormItem>
          <FormItem label="新密码">
            <Input type="password" v-model="Password.first_password" placeholder="请输入新密码" @on-blur="checkPassword">
              <Icon type="md-lock" slot="prefix"/>
              <Icon type="md-eye" slot="suffix" @click="is_show_password = false"/>
            </Input>
            <Input type="text" v-model="Password.first_password" v-if="!is_show_password" @on-blur="checkPassword">
              <Icon type="md-lock" slot="prefix"/>
              <Icon type="md-eye-off" slot="suffix" @click="is_show_password = true"/>
            </Input>
          </FormItem>
          <FormItem label="确认密码">
            <Input type="password" v-model="Password.new_password" placeholder="再次输入新密码"  @on-blur="checkPasswordTwo">
              <Icon type="md-lock" slot="prefix"/>
              <Icon type="md-eye-off" slot="suffix" @click="is_show_password_1 = false"/>
            </Input>
            <Input type="text" v-model="Password.new_password" v-if="!is_show_password_1"  @on-blur="checkPasswordTwo">
              <Icon type="md-lock" slot="prefix"/>
              <Icon type="md-eye-off" slot="suffix" @click="is_show_password_1 = true"/>
            </Input>
          </FormItem>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="passwordModal=false">取消</Button>
        <Button type="success" @click="passwordOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from "vuex";
import common from "../api/services/common/common";
import webfunction from "../api/services/webfunction";

export default {
  data() {
    return {
      is_show_password: true,
      is_show_password_1: true,
      activename: "1",
      isOK: true,
      showAccount: false,
      EmailModal: false,
      passwordModal: false,
      isDistributor: false,
      isDistributor_service: false,
      isDistributor_service_two: false,
      isDistributor_service_three: false,
      isDistributorTwo: false,
      isDistributorThree: false,
      isOneAndTwo: false,
      isQA: false,
      operate: false,
      Email: {
        Email: ""
      },
      Password: {
        old_password: "",
        first_password: "",
        new_password: ""
      },
      ruleValidate: {
        Email: [{
          required: true,
          message: "请输入邮箱地址",
          trigger: "blur"
        },
          {
//            pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/,
            pattern: /^[a-zA-Z0-9_.-]+(\@[a-zA-Z0-9_-]{2,100})+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入有效的邮箱地址',
            trigger: 'blur'
          }
          // {
          //   type: "email",
          //   message: "请输入有效的邮箱地址",
          //   trigger: "blur"
          // }
        ]
      }
    };
  },

    computed: {
    ...mapGetters([
      "user"
    ]),


    /*     activename: function() {
          if (
            this.$route.path.includes("MyTask") ||
            this.$route.path.includes("MyApply")
          ) {
            return "1";
          } else if (this.$route.path.includes("Distributormaster")) {
            return "2";
          } else if (this.$route.path.includes("Search")) {
            return "3";
          } else if (this.$route.path.includes("Workflow")) {
            return "4";
          } else {
            return "4";
          }
        } */
  },
  watch: {
    activename: function () {
      localStorage.setItem("dms-app-menu", this.activename);
    }
  },
  created() {
      if ((localStorage.group_name).indexOf(",") > -1) {
          debugger
          var group_names = localStorage.group_name.split(',');
          for (var group_name in group_names) {
              if (group_names[group_name] == "flow_distributor") {
                  this.isDistributor = true;
                  this.operate = true;
              }
              if (group_names[group_name] == "flow_distributor_service") {
                  this.isDistributor_service = true;
                  this.operate = true;
              }
              if (group_names[group_name] == "flow_distributor_service_two") {
                  if(this.isDistributor_service) {
                      this.isDistributor_service_two = false;
                  } else {
                      this.isDistributor_service_two = true;
                  }
                  this.operate = true;
              }
              if (group_names[group_name] == "flow_distributor_two") {
                  if(this.isDistributor) {
                      this.isDistributorTwo = false;
                  } else {
                      this.isDistributorTwo = true;
                  }
                  this.operate = true;
              }

          }

      } else {
          debugger
          if ((localStorage.group_name).indexOf("flow_distributor") > -1
                  && (localStorage.group_name).indexOf("flow_distributor_two") < 0
                  && (localStorage.group_name).indexOf("flow_distributor_service") < 0
                  && (localStorage.group_name).indexOf("flow_distributor_service_two") < 0) {
              this.isDistributor = true;
              this.operate = true;
          }
          if ((localStorage.group_name).indexOf("flow_distributor_service_two") > -1) {
              this.isDistributor_service_two = true;
              this.operate = true;
          }
          if ((localStorage.group_name).indexOf("flow_distributor_service") > -1
                  && (localStorage.group_name).indexOf("flow_distributor_service_two") < 0) {
              this.isDistributor_service = true;
              this.operate = true;
          }
          if ((localStorage.group_name).indexOf("flow_distributor_two") > -1) {
              this.isDistributorTwo = true;
              this.operate = true;
          }
          if(localStorage.group_name == '' || localStorage.group_name == null || localStorage.group_name == undefined) {
              this.isDistributorTwo = false;
              if(this.user.is_staff) {
                  this.isDistributorTwo = false;
                  this.isDistributor_service = false;
                  this.isDistributor_service_two = false;
                  this.isDistributor = false;
              }
          }
      }




//    if ((localStorage.group_name).indexOf(",") > -1) {
//      debugger
//      var group_names = localStorage.group_name.split(',');
//      for (var group_name in group_names) {
//        if (group_names[group_name] == "flow_distributor") {
//            this.isDistributor = true;
//            this.operate = true;
//        }
//        if (group_names[group_name] == "flow_distributor_service") {
//          this.isDistributor_service = true;
//          this.isDistributor = true;
//            this.operate = true;
//
//        }
//        if (group_names[group_name] == "flow_distributor_service_two") {
//          this.isDistributor_service_two = true;
//            this.isDistributor_service_three = true;
//            this.operate = true;
//        }
//        if (group_names[group_name] == "flow_distributor_two") {
//          this.isDistributorTwo = true;
//            if(this.isDistributor) {
//                this.isDistributorThree = false;
//            } else {
//                this.isDistributorThree = true;
//            }
//
//            this.operate = true;
//        }
//      }
//    } else {
//      if ((localStorage.group_name).indexOf("flow_distributor") > -1 && (localStorage.group_name).indexOf("flow_distributor_two") < 0) {
//        this.isDistributorTwo = true;
//          this.operate = true;
//      }
//
//
//      if ((localStorage.group_name).indexOf("flow_distributor_two") > -1) {
//          if(this.isDistributor) {
//              this.isDistributorThree = false;
//          } else {
//              this.isDistributorThree = true;
//          }
//          this.operate = true;
//      }
//      if ((localStorage.group_name).indexOf("flow_distributor_service_two") > -1) {
//        this.isDistributor_service_two = true;
//          this.operate = true;
//
//      }
//    }
//    if (this.isDistributor == true && this.isDistributor_service_two == true && this.isDistributorTwo == true && this.isDistributorThree == true) {
//      this.isDistributor = false;
//      this.isDistributorTwo = false;
//      this.isDistributorThree = false;
//    }
//    if (this.isDistributor == true && this.isDistributorTwo == true && this.isDistributor_service_two == true) {
//      this.isOneAndTwo = true;
//      this.isDistributorThree = false;
//    }
//
//
//      if (this.isDistributor == true && this.isDistributor_service == true) {
//          this.isDistributor = true;
//          this.isDistributorTwo = false;
//          this.isDistributorThree = false;
//      }



    if (localStorage.getItem("dms-app-menu")) {
      this.activename = localStorage.getItem("dms-app-menu");
    }
    //返回bu列表，区域列表和产品线列表的信息
    webfunction.getbu().then(response => {
      this.set_bu(response);
    });
    //获取公共的系统主数据
    webfunction.getCommon().then(response => {
      response.sort((a, b) => b.name.localeCompare(a.name, 'zh-CN'))
      this.set_Common(response);
    });
    //返回系统支持的流程类型主数据，用于流程类型下拉控件，或是流程入口使用。
    webfunction.getflowtype().then(response => {
      this.set_flowtype(response);
    });
    webfunction.getqueryflowtype().then(response => {
      this.set_queryflowtype(response);
    });
    webfunction.getproductParentList().then(response => {
      this.set_productParentList(response)
    });
    webfunction.getproductLineParentList().then(response => {
      this.set_productLineParentList(response)
    });
    this.set_user(JSON.parse(localStorage.getItem("dms-app-user")));
    //获取省市下面的主数据
    /*     webfunction.getHosipitals().then(response => {
      this.set_hosipitals(response);
    }); */
    //区域，省,市，获取3个下拉框中的数据, region,region_province,province_city
    common.get_location().then(response => {
      console.log(response.Province.findIndex((item) => item.province_code === '9999999999'))
      if (response.Province.length > 0) {
        response.Province.splice(response.Province.findIndex((item) => item.province_code === '9999999999'), 1);
      }
      this.set_location(response);
    });
    if ((localStorage.group_name).indexOf("flow_qa") > -1 || (localStorage.group_name).indexOf("sys_manager") > -1) {
      this.isQA = true;
    }
    if ((localStorage.group_name).indexOf("flow_channel") > -1 || (localStorage.group_name).indexOf("sys_manager") > -1) {
      this.isQA = true;
    }
    if ((localStorage.group_name).indexOf("flow_channel_operate") > -1 || (localStorage.group_name).indexOf("sys_channel") > -1) {
      this.operate = true;
    }
  },
  methods: {
    downloadAttachment: function () {
      var webUrl = window.location.href.replace(this.$route.fullPath, "");
      window.open(`https://dms.zimmerbiomet.cn/` + '/static/uploads/temp/1571/经销商管理系统使用指南_一级经销商.pdf', '_blank');
    },
    downloadAttachmentTwo: function () {
      var webUrl = window.location.href.replace(this.$route.fullPath, "");
      window.open(`https://dms.zimmerbiomet.cn/` + '/static/uploads/temp/1571/经销商管理系统使用指南_次级经销商.pdf', '_blank');
    },
    downloadAttachment_service: function () {
      var webUrl = window.location.href.replace(this.$route.fullPath, "");
      window.open(`https://dms.zimmerbiomet.cn/` + '/static/uploads/temp/1571/一级服务商使用指南.pdf', '_blank');
    },
    downloadAttachmentTwo_service: function () {
      var webUrl = window.location.href.replace(this.$route.fullPath, "");
      window.open(`https://dms.zimmerbiomet.cn/` + '/static/uploads/temp/1571/次级服务商使用指南.pdf', '_blank');
    },
    ...mapActions([
      "set_bu",
      "set_Common",
      "set_flowtype",
      "set_queryflowtype",
      "set_productParentList",
      "set_productLineParentList",
      "set_location",
      "set_user"
    ]),
    menuonselect(name) {
      this.activename = '0';
    },
    quit() {
      //localStorage.clear();
      // localStorage.setItem("dms-app-returnURL", this.$router.);
      this.$router.push({
        name: "login"
      });
    },

    getEmail(value) {
      this.$refs[value].validate(valid => {
        if (valid) {
            debugger
            if(this.Email.Email != '' && this.Email.Email != null) {
                let e = this.Email.Email.substring(0, this.Email.Email.indexOf('@'))
                if(e.length < 4) {
                    this.$Message.warning("@前的字符不能小于4位");
                    this.Email.Email = null;
                    return false;
                }
            }
          var map = {
            email: this.Email.Email,
            userId: localStorage.getItem("user_id"),
            companyName: this.user.company_name
          }
          webfunction
            .checkEmail(map)
            .then(response => {
              debugger
              if (response == "userEmail") {
                this.$Message.warning("该邮箱在用户中已存在");
              } else if (response == "userCompanyEmail") {
                this.$Message.warning("该邮箱在一级商中已存在");
              } else if (response == "userCompanyTwoEmail") {
                this.$Message.warning("该邮箱在二级商中已存在");
              } else {
                this.isOK = false;
              }
            })
        }
      });
    },

    emailOk(name) {


        this.$refs[name].validate(valid => {
            if (valid) {
                var map = {
                    email: this.Email.Email,
                    userId: localStorage.getItem("user_id"),
                    companyName: this.user.company_name
                }
                webfunction
                        .checkEmail(map)
                        .then(response => {
                            debugger
                            if (response == "userEmail") {
                                this.$Message.warning("该邮箱在用户中已存在");
                            } else if (response == "userCompanyEmail") {
                                this.$Message.warning("该邮箱在一级商中已存在");
                            } else if (response == "userCompanyTwoEmail") {
                                this.$Message.warning("该邮箱在二级商中已存在");
                            } else {
                                this.$refs[name].validate(valid => {
                                    if (valid) {
                                        debugger
                                        var map = {
                                            email: this.Email.Email,
                                            userId: localStorage.getItem("user_id"),
                                            companyName: this.user.company_name
                                        }
                                        webfunction
                                                .javaModifyEmail(map)
                                                .then(response => {
                                                    if (response == "success") {
                                                        this.$Message.success("更新成功");
                                                        let loginInfo = JSON.parse(localStorage.getItem("dms-app-login"));
                                                        if (loginInfo) {
                                                            localStorage.setItem("dms-app-login", JSON.stringify({
                                                                "username": this.Email.Email,
                                                                "password": loginInfo.password,
                                                                "checked": loginInfo.checked
                                                            }));
                                                        }
                                                        var app_user = JSON.parse(localStorage.getItem("dms-app-user"));
                                                        app_user.username = this.Email.Email;
                                                        app_user.email = this.Email.Email;
                                                        localStorage.setItem("dms-app-user", JSON.stringify(app_user));
                                                        localStorage.setItem("user_name", this.Email.Email);
                                                        this.user.username = this.Email.Email
                                                        this.EmailModal = false
                                                    }

                                                })
                                    }
                                });
                            }
                        })
            }
        });



    },


      checkPassword() {
          // var regPassword = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z\s]+$)\S{8,20}$/
          // if (!regPassword.test(this.Password.first_password)) {
          //     this.$Message.error("至少8个字符，不能全部是数字")
          //     this.Password.first_password = ''
          // }
        // 密码长度检查
        if (this.Password.first_password.length < 12) {
          this.$Message.error({content: "密码长度不足12位", duration: 10  })
          return false
        }



        var userName =  this.user.username;
        if(userName != null && userName.indexOf('@') > -1) {
          var emailUsername = userName.split('@')[0];
          if(this.Password.first_password  &&
            (this.Password.first_password.toLowerCase().indexOf(emailUsername.toLowerCase()) > -1 || this.Password.first_password.indexOf(userName) > -1 ) ) {
            this.$Message.error({content: "密码不能包含自己的邮箱", duration: 10  })
            this.Password.first_password = ''
            return false;
          }
        } else {
          if(this.Password.first_password &&
            this.Password.first_password.indexOf(userName) > -1) {
            this.$Message.error({content: "密码不能包含自己的手机号码", duration: 10  })
            this.Password.first_password = ''
            return false;
          }
        }

        for (let i = 0; i <= this.Password.old_password.length - 5; i++) {
          const segment = this.Password.old_password.substring(i, i + 5);
          if (this.Password.first_password.includes(segment)) {
            this.$Message.error({content: '新密码包含旧密码中连续的5个字符', duration: 10  })
            this.Password.first_password = ''
            return false;
          }
        }

        // 必须包含大写字母
        // if (!/[A-Z]/.test(this.Password.first_password)) {
        //   this.$Message.error("密码必须包含至少一个大写字母")
        //   return false
        // }
        //
        // // 必须包含小写字母
        // if (!/[a-z]/.test(this.Password.first_password)) {
        //   this.$Message.error("密码必须包含至少一个小写字母")
        //   return false
        // }
        //
        // // 必须包含特殊字符
        // if (!/[^A-Za-z0-9]/.test(this.Password.first_password)) {
        //   this.$Message.error("密码必须包含至少一个特殊字符")
        //   return false
        // }
        // 检查四类字符的存在性
        const hasUpperCase = /[A-Z]/.test(this.Password.first_password);
        const hasLowerCase = /[a-z]/.test(this.Password.first_password);
        const hasNumber = /[0-9]/.test(this.Password.first_password);         // 新增数字检查
        const hasSpecialChar = /[^A-Za-z0-9]/.test(this.Password.first_password);

        // 计算满足的类别数量
        const categoryCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar]
          .filter(Boolean).length;

        // 验证至少包含3类字符
        if (categoryCount < 3) {
          this.$Message.error({content: "密码至少需包含大写字母、小写字母、数字、特殊字符中的3类", duration: 10  });
          return false;
        }

        // 禁止3个以上连续键盘字符
        const keyboardSequences = [
          'qwe', 'wer', 'ert', 'rty', 'tyu', 'yui', 'uio', 'iop',
          'asd', 'sdf', 'dfg', 'fgh', 'ghj', 'hjk', 'jkl',
          'zxc', 'xcv', 'cvb', 'vbn', 'bnm',
          '123', '234', '345', '456', '567', '678', '789', '890',
          '098', '987', '876', '765', '654', '543', '432', '321', '210'
        ];

        for (const seq of keyboardSequences) {
          if (this.Password.first_password.toLowerCase().includes(seq)) {
            this.$Message.error({content: `密码包含禁止的键盘连续字符序列: ${seq}`, duration: 10  })
            return false
          }
        }

        // 禁止生日格式(YYYYMMDD)
        const birthdayRegex = /(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])/;
        if (birthdayRegex.test(this.Password.first_password)) {
          this.$Message.error({content: "密码不能使用生日格式", duration: 10  })
          return false
        }


      },
      checkPasswordTwo() {
          var regPassword = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z\s]+$)\S{8,20}$/
          if(this.Password.new_password != this.Password.first_password) {
              this.$Message.error("2次输入的密码不一致")
              this.Password.new_password = ''
          }

      },


    passwordOk() {
      // 密码长度检查
      if (this.Password.first_password.length < 12) {
        this.$Message.error({content: "密码长度不足12位", duration: 10  })
        return false
      }



      var userName =  this.user.username;
      if(userName != null && userName.indexOf('@') > -1) {
        var emailUsername = userName.split('@')[0];
        if(this.Password.first_password  &&
          (this.Password.first_password.toLowerCase().indexOf(emailUsername.toLowerCase()) > -1 || this.Password.first_password.indexOf(userName) > -1 ) ) {
          this.$Message.error({content: "密码不能包含自己的邮箱", duration: 10  })
          this.Password.first_password = ''
          return false;
        }
      } else {
        if(this.Password.first_password &&
          this.Password.first_password.indexOf(userName) > -1) {
          this.$Message.error({content: "密码不能包含自己的手机号码", duration: 10  })
          this.Password.first_password = ''
          return false;
        }
      }

      for (let i = 0; i <= this.Password.old_password.length - 5; i++) {
        const segment = this.Password.old_password.substring(i, i + 5);
        if (this.Password.first_password.includes(segment)) {
          this.$Message.error({content: '新密码包含旧密码中连续的5个字符', duration: 10  })
          this.Password.first_password = ''
          return false;
        }
      }

      // 必须包含大写字母
      // if (!/[A-Z]/.test(this.Password.first_password)) {
      //   this.$Message.error("密码必须包含至少一个大写字母")
      //   return false
      // }
      //
      // // 必须包含小写字母
      // if (!/[a-z]/.test(this.Password.first_password)) {
      //   this.$Message.error("密码必须包含至少一个小写字母")
      //   return false
      // }
      //
      // // 必须包含特殊字符
      // if (!/[^A-Za-z0-9]/.test(this.Password.first_password)) {
      //   this.$Message.error("密码必须包含至少一个特殊字符")
      //   return false
      // }
      // 检查四类字符的存在性
      const hasUpperCase = /[A-Z]/.test(this.Password.first_password);
      const hasLowerCase = /[a-z]/.test(this.Password.first_password);
      const hasNumber = /[0-9]/.test(this.Password.first_password);         // 新增数字检查
      const hasSpecialChar = /[^A-Za-z0-9]/.test(this.Password.first_password);

      // 计算满足的类别数量
      const categoryCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar]
        .filter(Boolean).length;

      // 验证至少包含3类字符
      if (categoryCount < 3) {
        this.$Message.error({content: "密码至少需包含大写字母、小写字母、数字、特殊字符中的3类", duration: 10  });
        return false;
      }

      // 禁止3个以上连续键盘字符
      const keyboardSequences = [
        'qwe', 'wer', 'ert', 'rty', 'tyu', 'yui', 'uio', 'iop',
        'asd', 'sdf', 'dfg', 'fgh', 'ghj', 'hjk', 'jkl',
        'zxc', 'xcv', 'cvb', 'vbn', 'bnm',
        '123', '234', '345', '456', '567', '678', '789', '890',
        '098', '987', '876', '765', '654', '543', '432', '321', '210'
      ];

      for (const seq of keyboardSequences) {
        if (this.Password.first_password.toLowerCase().includes(seq)) {
          this.$Message.error({content: `密码包含禁止的键盘连续字符序列: ${seq}`, duration: 10  })
          return false
        }
      }

      // 禁止生日格式(YYYYMMDD)
      const birthdayRegex = /(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])/;
      if (birthdayRegex.test(this.Password.first_password)) {
        this.$Message.error({content: "密码不能使用生日格式", duration: 10  })
        return false
      }
      if(this.Password.new_password) {
        webfunction
          .modifyPassword(this.Password.old_password, this.Password.new_password, this.Password.first_password)
          .then(response => {
            this.$Message.success(response.message);
            this.$router.push({
              name: "login"
            });
          })
      }

    },

  }
};
</script>



// WEBPACK FOOTER //
// src/view/Main.vue